module.exports = __webpack_public_path__ + "static/img/point.96ebc451.png";